import React from 'react';
import { AdvertorialPage } from './components/AdvertorialPage';
export function App() {
  return <AdvertorialPage data-id="element-0" />;
}